<template>
  <div class="content-body">
    <div class="container-fluid">
      <Breadcrumb name="Deposit Money" :breadcrumb="breadcrumb" />
      <!-- row -->
      <div class="row">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Details</h4>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <Form @submit="sendCall">
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Card Holder Name</label>
                    <div class="col-sm-9">
                      <Field
                          class="form-control"
                          type="text"
                          name="cardHolderName"
                          rules="required"
                      />
                      <ErrorMessage name="cardHolderName"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Card Number</label>
                    <div class="col-sm-9">
                      <Field
                          class="form-control"
                          type="text"
                          name="cardNumber"
                          rules="required|numeric"
                      />
                      <ErrorMessage name="cardNumber"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Exp Month</label>
                    <div class="col-sm-9">
                      <Field
                          class="form-control"
                          type="text"
                          name="expMonth"
                          rules="required|numeric|max:2|min:2"
                          placeholder="e.g. 09"
                      />
                      <ErrorMessage name="expMonth"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Exp Year</label>
                    <div class="col-sm-9">
                      <Field
                          class="form-control"
                          type="text"
                          name="expYear"
                          rules="required|numeric|max:2|min:2"
                          placeholder="e.g. 23"
                      />
                      <ErrorMessage name="expYear"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">CVC</label>
                    <div class="col-sm-9">
                      <Field
                          class="form-control"
                          type="text"
                          name="cvc"
                          rules="required|numeric"
                      />
                      <ErrorMessage name="cvc"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-10">
                      <Button class="btn btn-primary" :loading="loader" >Deposit</Button>
                      <Button class="btn btn-dark ml-1" type="button" @click="$router.push({name:'deposit-money'})">Back</Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <TransactionSuccessModal :show="showModal" :data="confirmationData"
                           @hide="hideRedirectingModal"></TransactionSuccessModal>
  <RedirectingModal :show="showRedirectModal"
                    @hide="showRedirectModal = false"></RedirectingModal>
</template>

<script>
export default {
  mounted() {
  },
  data() {
    return {
      loader: false,
      yearList:[],
      showModal: false,
      showRedirectModal: false,
      confirmationData:null,

    }
  },
  methods: {
    hideRedirectingModal(){
      // alert(33)
      this.showModal = false
      this.$router.push({name: 'index'})
    },
    sendCall(values) {
      let data = values
      data.hash = this.$store.getters.getBalanceLimitHash
      this.loader = true
      this.makeRequest('post', 'v1/initiate-deposit', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            if(callResponse.response.data.data){
              let data = callResponse.response.data.data

              this.emitter.emit("update-balance", true)

              if(data.bypass3DS){
                //true
                this.confirmationData = data
                this.showModal = true
              }else{
                //false
                this.showRedirectModal = true
                setTimeout(()=>{
                  this.showRedirectModal = false

                },2000)
                setTimeout(()=>{
                  this.redirect(data.paymentUrl)

                },2000)


              }
            }
          }
          else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
    generateYears(){
      var time = new Date();
      var year = time.getYear();
      if (year < 1900) {
        year = year + 1900;
      }
      var date = year - 20; /*change the '20' to the number of years in the past you want to show */
      var future = year + 20; /*change the '20' to the number of years in the future you want to show */
      do {
        date++;
        this.yearList.push(date)
      }
      while (date < future)

    },
    redirect(url) {
      // let route = this.$router.resolve(url);
      // let route = this.$router.resolve('/link/to/page'); // This also works.
      window.open(url, '_blank');
      this.$router.push({name:'index'})

    }
  },
}
</script>

